<div class="firstmeeting-popup-container">
  <!-- Header -->
  <div class="popup-header">
    <h2>Create First Meeting</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn" [disabled]="isSubmitting">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="popup-content">
    <form [formGroup]="form">
      
      <!-- Client Information Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>person</mat-icon>
          Client Information
        </h3>
        
        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Client Name</mat-label>
            <input matInput formControlName="clientName" placeholder="Enter client name">
            <mat-error *ngIf="form.get('clientName')?.hasError('required')">
              Client name is required
            </mat-error>
            <mat-error *ngIf="form.get('clientName')?.hasError('minlength')">
              Name must be at least 2 characters
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="Enter 10-digit phone number">
            <mat-error>{{ getPhoneNumberError() }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Email ID</mat-label>
            <input matInput formControlName="emailId" placeholder="Enter email address">
            <mat-error>{{ getEmailError() }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Debit Information Section -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">
            <mat-icon>credit_card</mat-icon>
            Debit Information
          </h3>
          <button type="button" mat-raised-button color="primary" (click)="addDebt()" class="add-btn">
            <mat-icon>add</mat-icon>
            Add Debt
          </button>
        </div>

        <div class="items-list" *ngIf="debtList.length > 0">
          <div *ngFor="let debt of debtList; let i = index" class="item-row">
            <mat-form-field class="form-field">
              <mat-label>Bank Name</mat-label>
              <input matInput [(ngModel)]="debt.bankName" [ngModelOptions]="{standalone: true}" placeholder="Enter bank name">
            </mat-form-field>

            <mat-form-field class="form-field">
              <mat-label>Balance</mat-label>
              <input matInput type="number" [(ngModel)]="debt.balance" [ngModelOptions]="{standalone: true}" placeholder="Enter balance">
            </mat-form-field>

            <button type="button" mat-icon-button color="warn" (click)="removeDebt(i)" class="remove-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="debtList.length === 0" class="empty-state">
          <p>No debit information added yet</p>
        </div>
      </div>

      <!-- Assets Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>home</mat-icon>
          Assets
        </h3>

        <!-- First Mortgage -->
        <div class="subsection">
          <div class="subsection-header">
            <h4>First Mortgage</h4>
            <button type="button" mat-raised-button color="primary" (click)="addFirstMortgage()" class="add-btn">
              <mat-icon>add</mat-icon>
              Add
            </button>
          </div>

          <div class="items-list" *ngIf="firstMortgageList.length > 0">
            <div *ngFor="let mortgage of firstMortgageList; let i = index" class="item-row">
              <mat-form-field class="form-field">
                <mat-label>Mortgage Value</mat-label>
                <input matInput type="number" [(ngModel)]="mortgage.value" [ngModelOptions]="{standalone: true}" placeholder="Enter value">
              </mat-form-field>

              <button type="button" mat-icon-button color="warn" (click)="removeFirstMortgage(i)" class="remove-btn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="firstMortgageList.length === 0" class="empty-state">
            <p>No first mortgage added</p>
          </div>
        </div>

        <!-- Second Mortgage -->
        <div class="subsection">
          <div class="subsection-header">
            <h4>Second Mortgage</h4>
            <button type="button" mat-raised-button color="primary" (click)="addSecondMortgage()" class="add-btn">
              <mat-icon>add</mat-icon>
              Add
            </button>
          </div>

          <div class="items-list" *ngIf="secondMortgageList.length > 0">
            <div *ngFor="let mortgage of secondMortgageList; let i = index" class="item-row">
              <mat-form-field class="form-field">
                <mat-label>Mortgage Value</mat-label>
                <input matInput type="number" [(ngModel)]="mortgage.value" [ngModelOptions]="{standalone: true}" placeholder="Enter value">
              </mat-form-field>

              <button type="button" mat-icon-button color="warn" (click)="removeSecondMortgage(i)" class="remove-btn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="secondMortgageList.length === 0" class="empty-state">
            <p>No second mortgage added</p>
          </div>
        </div>

        <!-- Property Value and LOP -->
        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Property Value</mat-label>
            <input matInput formControlName="propertyValue" placeholder="Enter property value">
            <mat-error *ngIf="form.get('propertyValue')?.hasError('required')">
              Property value is required
            </mat-error>
          </mat-form-field>

          <div class="radio-group">
            <label>LOP Needed</label>
            <mat-radio-group formControlName="lopNeeded" class="radio-options">
              <mat-radio-button value="yes">Yes</mat-radio-button>
              <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!-- Vehicle Information Section -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">
            <mat-icon>directions_car</mat-icon>
            Vehicle Information
          </h3>
          <button type="button" mat-raised-button color="primary" (click)="addVehicle()" class="add-btn">
            <mat-icon>add</mat-icon>
            Add Vehicle
          </button>
        </div>

        <div class="items-list" *ngIf="vehicleList.length > 0">
          <div *ngFor="let vehicle of vehicleList; let i = index" class="item-row">
            <mat-form-field class="form-field">
              <mat-label>Model</mat-label>
              <input matInput [(ngModel)]="vehicle.model" [ngModelOptions]="{standalone: true}" placeholder="Enter vehicle model">
            </mat-form-field>

            <mat-form-field class="form-field">
              <mat-label>Year</mat-label>
              <input matInput type="number" [(ngModel)]="vehicle.year" [ngModelOptions]="{standalone: true}" placeholder="Enter year">
            </mat-form-field>

            <mat-form-field class="form-field">
              <mat-label>Finance</mat-label>
              <input matInput type="number" [(ngModel)]="vehicle.finance" [ngModelOptions]="{standalone: true}" placeholder="Enter finance amount">
            </mat-form-field>

            <button type="button" mat-icon-button color="warn" (click)="removeVehicle(i)" class="remove-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="vehicleList.length === 0" class="empty-state">
          <p>No vehicle information added yet</p>
        </div>
      </div>

      <!-- Business Information Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>business</mat-icon>
          Business Information
        </h3>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Business Name</mat-label>
            <input matInput formControlName="businessName" placeholder="Enter business name">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>HST</mat-label>
            <input matInput formControlName="businessHst" placeholder="Enter HST number">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Article of Incorporation</mat-label>
            <input matInput formControlName="businessArticle" placeholder="Enter article of incorporation">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Business Debt</mat-label>
            <input matInput type="number" formControlName="businessDebt" placeholder="Enter business debt">
          </mat-form-field>
        </div>
      </div>

      <!-- Notes Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>note</mat-icon>
          Notes
        </h3>

        <mat-form-field class="form-field full-width">
          <mat-label>Additional Notes</mat-label>
          <textarea matInput formControlName="note" placeholder="Enter any additional notes" rows="4"></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="popup-footer">
    <button mat-raised-button (click)="onCancel()" class="cancel-btn" [disabled]="isSubmitting">
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid || isSubmitting" class="submit-btn">
      <mat-icon *ngIf="!isSubmitting">save</mat-icon>
      <mat-spinner *ngIf="isSubmitting" diameter="20" class="spinner"></mat-spinner>
      {{ isSubmitting ? 'Creating...' : 'Create First Meeting' }}
    </button>
  </div>
</div>
